import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/stock-areas", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-areas", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id","area_name"]; //仅筛选少许必要字段
    return Request('get', "api/stock-areas/select", data, false, false, true);
}

async function fetchOne(id) {
    return Request('get', "api/stock-areas/view?id=" + id);
}

async function save(id , data) {
    if(id) {
        return Request('post', "api/stock-areas/edit", data)
    } else {
        return Request('post', "api/stock-areas/add", data)
    }
}

async function del(id) {
    return Request('get', "api/stock-areas/delete/" + id);
}


export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    fetchOne,
    save,
    del,
};